import {AxiosResponse} from 'axios'
import {PersonTagRequest, PhotoPersonTag} from './types'
import {HttpInstance} from '../createHttpInstance'

export interface TagPhoto<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const tagPhoto: TagPhoto<PersonTagRequest, PhotoPersonTag> = (
  http,
  params,
) => {
  const {ClientID, PersonID, PhotoID} = params

  const path = '/v1/photos/{photoid}/person-tags/{personid}'
    .replace('{personid}', PersonID.toString())
    .replace('{photoid}', PhotoID.toString())

  return http.request<PhotoPersonTag>({
    method: 'PUT',
    url: `${path}?clientid=${ClientID}`,
  })
}
